import React, { useState } from "react";
import MasterLayout from "../../components/Layout/MasterLayout";
import {
  getItem,
  showErrorToast,
} from "../../utils/Functions";
import {
  Accordion,
  Badge,
  Button,
  Card,
  Col,
  Container,
  Modal,
  Row,
  Tab,
  Tabs,
  ListGroup,
} from "react-bootstrap";
import { scrollTo } from "../../components/AnimateScroll/scrollTo";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { applyJob, jobListing } from "./action";
import { paths } from "../../router/Constant";
import { useHistory, useLocation } from "react-router-dom";

const JobOpenings = () => {
  // Scroll to top script
  let userInfo = JSON.parse(getItem("User"));
  let type = getItem("type");
  const history = useHistory();
  const location = useLocation();
  const isOpeningsRoute = location.pathname === paths.jobOpenings;
  const [visible, setVisible] = useState(false);
  const [defaultTab, setDefaultTab] = useState("");
  const [ableToApply, setAbleToApply] = useState(true);

  const offeredCandidateReduxData = useSelector(
    (state) => state.profile.OfferedCandidateProfileDetails
  );

  // useEffect(() => {
  //   dispatch(offeredCandidateProfile(userInfo._id));
  // }, [userInfo._id]);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  window.addEventListener("scroll", toggleVisible);
  // Scroll to top script

  const dispatch = useDispatch();
  const jobList = useSelector((state) => state.jobOpening.jobsListings);

  const [urgentJobs, setUrgentJobs] = useState([]);
  const [jobData, setJobData] = useState({});

  useEffect(() => {
    dispatch(jobListing());
  }, []);
  useEffect(() => {
    if (jobList) {
      let list = [];
      jobList &&
        jobList?.webFormJobOpenings?.length > 0 &&
        jobList?.webFormJobOpenings?.map((job) => {
          job.isUrgent && list.push(job);
          setUrgentJobs(list);
        });
      if (type === "candidate" && jobList?.appliedJobList?.length > 0) {
        setDefaultTab("interview");
      } else {
        setDefaultTab("job-listing");
      }
      if (jobList?.appliedJobList?.length > 0) {
        const hasInvalidValue = jobList?.appliedJobList.some(
          (item) => item.KEY !== "NEW_CANDIDATE" && item.KEY !== "SHORTLISTED"
        );

        if (hasInvalidValue) {
          setAbleToApply(false);
        } else {
          setAbleToApply(true);
          console.log("Array only contains 'a' and 'b'");
        }
      }
    }
  }, [jobList]);

  const hasOtherJobs = !!jobList?.webFormJobOpenings?.some(
    (job) => !job.isUrgent
  );

  const renderTableHeader = () => (
    <div className="job-table-header">
      <div className="job-th position-col">POSITION</div>
      <div className="job-th department-col">DEPARTMENT</div>
      <div className="job-th experience-col">EXPERIENCE</div>
      <div className="job-th mode-col">MODE</div>
      <div className="job-th link-col">LINK</div>
    </div>
  );

  const renderJobCard = (job) => {
    const department = job?.department || job?.category || "Engineering";
    const experience =
      job?.workExperience_min || job?.workExperience_max
        ? `${job.workExperience_min}-${job.workExperience_max} yrs`
        : job?.experience ||
          (job?.minExp ? `${job.minExp}-${job.maxExp} yrs` : "4-10 yrs");
    const mode = job?.mode || job?.jobType || "HYBRID";

    return (
      <div key={job?._id} className="full_time listing-box job-row-card">
        <a
          href={`/job-details/${job?._id}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setJobData(job)}
          title={job && job.title}
        >
          <div className="job-col position-col">
            <h4 className="job-title-text">{job && job.title}</h4>
            {job?.isUrgent && <span className="urgent-badge">URGENT</span>}
          </div>
          <div className="job-col department-col">
            <span className="dept-text">{department}</span>
          </div>
          <div className="job-col experience-col">
            <span className="exp-text">{experience}</span>
          </div>
          <div className="job-col mode-col">
            <span className="mode-badge">{mode}</span>
          </div>
          <div className="job-col link-col">
            <span className="link-arrow-btn">
              <i className="bx bx-up-arrow-alt" />
            </span>
          </div>
        </a>
      </div>
    );
  };

  // const dispatch = useDispatch();
  // const careerDetails = useSelector((state) => state.career.jobDetailsLising);

  // useEffect(() => {
  //   dispatch(jobListing());
  // }, []);

  //

  /******************* 
  @Purpose : Used to handle scroll
  @Parameter :()
  @Author : INIC
  ******************/
  const handleScroll = () => {
    document.getElementById("uploadBtn");
    scrollTo({ id: "jobOpening" });
  };

  /******************* 
  @Purpose : Used to handle scroll
  @Parameter :()
  @Author : INIC
  ******************/
  const handleScrollBtn = () => {
    document.getElementById("uploadBtn2");
    scrollTo({ id: "offerSection" });
  };

  const [modalShow, setModalShow] = React.useState(false);
  const handleClose = () => {
    setModalShow(false);
    setJobData({});
  };

  const handleApply = (jobDatas) => {
    let qualification = getItem("qualification") ?? "";
    if (type === "candidate") {
      if (ableToApply) {
        const firstEducation =
          offeredCandidateReduxData?.educationalDetails[0] ?? "";

        const hasEmptyValue = Object.values(firstEducation).some(
          (val) => val === null || val === ""
        );
        if (
          offeredCandidateReduxData.basicInfo.firstName === "" ||
          offeredCandidateReduxData.basicInfo.lastName === "" ||
          offeredCandidateReduxData.basicInfo.mobile === "" ||
          offeredCandidateReduxData.basicInfo.email === "" ||
          offeredCandidateReduxData.basicInfo.gender === "" ||
          offeredCandidateReduxData.basicInfo.jobLocation === "" ||
          offeredCandidateReduxData.basicInfo.noticePeriod === "" ||
          qualification === "" ||
          qualification === undefined ||
          offeredCandidateReduxData.professionalDetails.skillSet.length === 0 ||
          offeredCandidateReduxData.professionalDetails.totalExprience === "" ||
          offeredCandidateReduxData.professionalDetails.relevantExperience ===
            "" ||
          offeredCandidateReduxData.professionalDetails.currentSalary === "" ||
          offeredCandidateReduxData.professionalDetails.expectedSalary === "" ||
          offeredCandidateReduxData.professionalDetails.currentDesignation ===
            "" ||
          offeredCandidateReduxData.professionalDetails.currentEmployer ===
            "" ||
          hasEmptyValue ||
          offeredCandidateReduxData.addressDetails.city === "" ||
          offeredCandidateReduxData.addressDetails.country === ""
        ) {
          showErrorToast(
            "Please update your profile with all required fields."
          );
        } else if (offeredCandidateReduxData.resume === "") {
          showErrorToast("Please upload your resume.");
        } else {
          let payload = {
            _id: userInfo._id,
            firstName: offeredCandidateReduxData.basicInfo.firstName ?? "",
            lastName: offeredCandidateReduxData.basicInfo.lastName ?? "",
            mobile: offeredCandidateReduxData.basicInfo.mobile ?? "",
            phoneCode: offeredCandidateReduxData.basicInfo.phoneCode ?? "91",
            emailId: offeredCandidateReduxData.basicInfo.email ?? "",
            currentEmployer:
              offeredCandidateReduxData.professionalDetails.currentEmployer ??
              "",
            totalExperiance:
              offeredCandidateReduxData.professionalDetails.totalExprience ??
              "",
            currentSalary:
              offeredCandidateReduxData.professionalDetails.currentSalary ?? "",
            qualification,
            city: offeredCandidateReduxData.addressDetails.city ?? "",
            resume: offeredCandidateReduxData.resume,
            postingTitle: [jobDatas._id],
            createdFrom: "webForm",
          };

          dispatch(applyJob(payload));
        }
      } else {
        showErrorToast(
          "Your hiring process is in progress, unable to apply for another job"
        );
      }
    } else {
      history.push(paths.addProfile);
    }

    setModalShow(false);
    setJobData({});
  };

  return (
    <>
      <MasterLayout>
        {/* Start: Hero — IndiaNIC style */}
        <section
          className="home-banner-wrap inic-hero"
          id="jobOpening"
          hidden={isOpeningsRoute}
        >
          <Container>
            <Row>
              <Col lg={10} xl={9}>
                <p className="label-mono inic-hero-eyebrow">
                  EST. 1998 · CANDIDATE PORTAL · JOIN THE TEAM
                </p>
                <h1 className="banner-main-caption">
                  <strong>IndiaNIC</strong>
                  <br />
                  Build with people who ship.
                </h1>
                <p className="banner-sub-caption">
                  Explore open roles and apply in minutes. Senior teams,
                  real products, and work that reaches production.
                </p>
                <div className="inic-hero-actions">
                  {/* <Button
                    className="inic-cta"
                    id="uploadBtn2"
                    onClick={() => handleScrollBtn()}
                  >
                    Explore openings <span aria-hidden>→</span>
                  </Button> */}
                </div>
                <div className="inic-hero-stats">
                  <div className="stat">
                    <span className="value">27+</span>
                    <span className="label">Years shipping</span>
                  </div>
                  <div className="stat">
                    <span className="value">500+</span>
                    <span className="label">AI-empowered experts</span>
                  </div>
                  <div className="stat">
                    <span className="value">8,000+</span>
                    <span className="label">Projects delivered</span>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        {/* Ends: Hero */}

        {/* Start: Main Content */}
        <section
          className="we-offer-section"
          id="offerSection"
          hidden={!isOpeningsRoute}
        >
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} xl={9}>
                <p className="label-mono section-kicker">Open roles</p>
                {jobList && jobList?.appliedJobList?.length !== 0 && (
                  <Tabs
                    defaultActiveKey="profile"
                    activeKey={defaultTab}
                    onSelect={(e) => {
                      setDefaultTab(e);
                    }}
                    className="mb-lg-5 mb-3"
                  >
                    {type === "candidate" && (
                      <Tab eventKey="interview" title="Applied Jobs">
                        {/* Start: Applied Jobs Card */}
                        <div className="jd-panel">
                          {jobList && jobList?.appliedJobList?.length === 0 && (
                            <Card className="jobs-not-found panel">
                              <span className="bx bx-error-circle text-danger"></span>
                              <h3 className="text-secondary mb-0">
                                Not Applied to any Jobs yet
                              </h3>
                            </Card>
                          )}
                          {jobList &&
                            jobList?.appliedJobList?.length > 0 &&
                            jobList?.appliedJobList?.map((data) => {
                              return (
                                <Accordion>
                                  <Accordion.Item eventKey="0">
                                    <Accordion.Header>
                                      {/* <img className="job-img-left" alt={data.title} src={bannerImage} width="60" height="60" /> */}
                                      <span className="job-img-left">
                                        {userInfo.firstName?.charAt(0) +
                                          "" +
                                          userInfo.lastName?.charAt(0)}
                                      </span>
                                      <div className="job-title-content">
                                        <h5 className="mb-0">{data.title}</h5>
                                        <p className="mb-0">
                                          Hiring Status:{" "}
                                          <span className="font-weight-medium text-primary">
                                            {data.status}
                                          </span>
                                        </p>
                                      </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      {data &&
                                        data.interviewList &&
                                        data.interviewList.length > 0 && (
                                          <>
                                            {" "}
                                            <Card.Title as="h6">
                                              Interview Status:
                                            </Card.Title>
                                            <ListGroup
                                              horizontal
                                              className="mb-3"
                                            >
                                              {data &&
                                                data.interviewList &&
                                                data.interviewList.map(
                                                  (round) => {
                                                    return (
                                                      <ListGroup.Item>
                                                        <Card.Text>
                                                          {
                                                            round?.interviewName
                                                              ?.interviewTitle
                                                          }
                                                          <Badge
                                                            bg="danger"
                                                            className="ms-2"
                                                          >
                                                            {
                                                              round.interviewstatus
                                                            }
                                                          </Badge>
                                                        </Card.Text>
                                                      </ListGroup.Item>
                                                    );
                                                  }
                                                )}
                                            </ListGroup>
                                          </>
                                        )}
                                      {data.skillSet[0].length > 0 && (
                                        <>
                                          <Card.Title as="h6">
                                            Skills:
                                          </Card.Title>
                                          <Card.Text className="mb-3">
                                            {data &&
                                              data.skillSet &&
                                              data.skillSet[0].map((list) => {
                                                return (
                                                  <Badge
                                                    bg="gray"
                                                    className="me-2 text-secondary"
                                                  >
                                                    {list}
                                                  </Badge>
                                                );
                                              })}
                                          </Card.Text>{" "}
                                        </>
                                      )}
                                      <Card.Title as="h6">
                                        Job Description:
                                      </Card.Title>
                                      <div
                                        className="job-description-content"
                                        dangerouslySetInnerHTML={{
                                          __html: data && data.description,
                                        }}
                                      ></div>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              );
                            })}
                        </div>
                        {/* Ends: Applied Jobs Card */}
                      </Tab>
                    )}
                    <Tab
                      eventKey="job-listing"
                      title={
                        type === "candidate" ? "Other Jobs" : "Job Openings"
                      }
                    >
                      {/* Start: Other Job Listings */}
                      <>
                        {urgentJobs.length > 0 && (
                          <div className="position-listing">
                            <div className="listing-block">
                              <h3>
                                Explore openings<span> →</span>
                              </h3>
                              {renderTableHeader()}
                              <div className="listing-row">
                                {jobList &&
                                  jobList.webFormJobOpenings &&
                                  jobList.webFormJobOpenings.map(
                                    (job) => job.isUrgent && renderJobCard(job)
                                  )}
                              </div>
                            </div>
                          </div>
                        )}
                        <div className="position-listing">
                          <div className="listing-block">
                            <h3>Ways we can work together</h3>
                            {hasOtherJobs && renderTableHeader()}
                            <div className="listing-row">
                              {jobList &&
                                jobList.webFormJobOpenings &&
                                jobList.webFormJobOpenings.map(
                                  (job) => !job.isUrgent && renderJobCard(job)
                                )}
                            </div>
                          </div>
                        </div>
                      </>
                      {/* Ends: Other Job Listings */}
                    </Tab>
                  </Tabs>
                )}
                {jobList && jobList?.appliedJobList?.length === 0 && (
                  <>
                    {urgentJobs.length > 0 && (
                      <div className="position-listing">
                        <div className="listing-block">
                          <h3 className="mt-3">
                            Explore openings<span> →</span>
                          </h3>
                          {renderTableHeader()}
                          <div className="listing-row">
                            {jobList &&
                              jobList.webFormJobOpenings &&
                              jobList.webFormJobOpenings.map(
                                (job) => job.isUrgent && renderJobCard(job)
                              )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="position-listing">
                      <div className="listing-block">
                        <h3>Ways we can work together</h3>
                        {hasOtherJobs && renderTableHeader()}
                        <div className="listing-row">
                          {jobList &&
                            jobList.webFormJobOpenings &&
                            jobList.webFormJobOpenings.map(
                              (job) => !job.isUrgent && renderJobCard(job)
                            )}
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </Col>
            </Row>
          </Container>
        </section>
        {/* Ends: Main Content */}

        {/* Start: Scroll to Top btn */}
        {visible && (
          <div
            id="mouse_scroll"
            className="mouse_arrow scroll-to-top cursor-pointer"
            onClick={() => handleScroll()}
          >
            <span className="bx bx-up-arrow-alt mouse_icon"></span>
          </div>
        )}
        {/* Ends: Scroll to Top btn */}

        {/* Start: Job Description Modal */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={modalShow}
        >
          <Modal.Header className="border-0">
            <Modal.Title id="contained-modal-title-vcenter">
              {jobData.title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="py-0">
            <Card.Title className="fw-normal" as="h6">
              Skills:
            </Card.Title>
            <Card.Text className="mb-3">
              {jobData?.skillSet?.map((skill) => (
                <Badge bg="gray" className="me-2 text-secondary">
                  {skill}
                </Badge>
              ))}
            </Card.Text>
            <Card.Title className="fw-normal" as="h6">
              Work Experience:
            </Card.Title>
            <Card.Text className="mb-3">
              {jobData.workExperience_min} - {jobData.workExperience_max}
            </Card.Text>
            <Card.Title className="fw-normal" as="h6">
              Job Type:
            </Card.Title>
            <Card.Text className="mb-3">
              <Badge bg="gray" className="me-2 text-secondary">
                {jobData.jobType}
              </Badge>
            </Card.Text>
            <Card.Title className="fw-normal" as="h6">
              Job Description:
            </Card.Title>
            <div
              className="job-description-content"
              dangerouslySetInnerHTML={{ __html: jobData.description }}
            ></div>
          </Modal.Body>
          <Modal.Footer className="border-0">
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={() => handleApply(jobData)}>
              Apply here
            </Button>
          </Modal.Footer>
        </Modal>
        {/* Ends: Job Description Modal */}
      </MasterLayout>
    </>
  );
};

export default JobOpenings;
